class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => { this.classList.add('animate', 'active') });

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });
    if(document.querySelector("#Details-menu-drawer-container").hasAttribute("open")){
      document.querySelector("#Details-menu-drawer-container").removeAttribute("open");
      document.querySelector("#Details-menu-drawer-container").classList.remove("menu-opening");
      document.querySelector(".header__icon--menu").setAttribute("aria-expanded",false);
      document.body.classList.remove("overflow-hidden-tablet");
      document.querySelector(".section-header").classList.remove("menu-open");
    }
    if(document.querySelector(".header__search details").hasAttribute("open")){
      document.querySelector(".header__search details").removeAttribute("open");
      document.querySelector(".section-header").classList.remove("menu-open");
    }
    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState,discount,discountcode) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      // console.log(parsedState.sections[section.id],"parsedState.sections[section.id]")
      if(discount){
        const parser = new DOMParser();
        let CARThtml = parser.parseFromString(parsedState.sections[section.id], "text/html");
        var discount_applied = false;
        if(CARThtml.querySelector("ul.discounts.list-unstyled")){
          CARThtml.querySelectorAll("ul.discounts.list-unstyled").forEach((ele) => {
            if(ele.innerHTML){
              discount_applied = true;
              return false;
            }
          })
          if(discount_applied){
            console.log("discount applied",discount_applied)
            setTimeout(function(){
              document.querySelector("cart-coupon-form .error").classList.add("d-none");
              }, 500);
          }else{
            // setTimeout(function(){
            //   let pre_Val = discountcode;
            //   document.querySelector(".promo-code-wrap").classList.add("open");
            //   document.querySelector("cart-coupon-form .error").classList.remove("d-none");
            //   document.querySelector("cart-coupon-form input[type='text']").value = pre_Val;
            // }, 500);

              setTimeout(function(){
              let pre_Val = discountcode;

              let tpriceElement = document.querySelector(".totals__subtotal-value");
              let cartTotal = 0;

              if (tpriceElement) {
                  cartTotal = parseFloat(tpriceElement.getAttribute("data-tprice")) || 0;
              }

              document.querySelector(".promo-code-wrap").classList.add("open");
              // Error message logic
              if (cartTotal < 300) {
                  // Show custom mini error for orders under 300 ₪
                  document.querySelector("cart-coupon-form .mini-error").classList.remove("d-none");
              } else {
                  // Show standard error
                 document.querySelector("cart-coupon-form .error").classList.remove("d-none");
              }
              document.querySelector("cart-coupon-form input[type='text']").value = pre_Val;
            }, 500);
            
          }
        }
      }
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
        this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);


//Coupon Code
class PromoCodeSection extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.target.classList.contains('cart-coupon-main') ? this.querySelector('.promo-code-wrap').classList.toggle('open') : null;
  
    });
  }
}

customElements.define('promo-code-wrap', PromoCodeSection);


class CartCouponCodeButton extends HTMLElement {
  constructor() {
    super();
    let current_form = this;
    this.querySelector('#coupon-form').addEventListener('submit', (event) => {

      event.preventDefault();
      this.submitForm(current_form.querySelector('.promo-input.couponCode').value)
    });
  }
 

   applyCouponCode(discountCode) {
    return new Promise((resolve, reject) => {
      let discountApplyUrl = "https://" + window.location.host + "/discount/" + discountCode;
  
      // Create a hidden iframe to apply discount using the checkout session
      let i = document.createElement('iframe');
      i.style.display = 'none';
      
      // Success: Remove iframe after it loads and log success message
      i.onload = function() {
        console.log("Discount code applied successfully."); // Log success
        i.parentNode.removeChild(i); // Clean up the iframe
        resolve(); // Resolve the promise for success
      };
  
      // Error: Handle iframe loading error
      i.onerror = function() {
        console.error("Failed to apply discount code."); // Log error message
        i.parentNode.removeChild(i); // Clean up the iframe
        reject(new Error("Failed to apply discount code.")); // Reject with error
      };
  
      i.src = discountApplyUrl;
      document.body.appendChild(i); // Append iframe to the body
    });
  }
  
  submitForm(discountCode){
    let current_this = this
    current_this.applyCouponCode(discountCode)
    .then(() => {
        console.log("Discount applied successfully!");
        fetch(`${routes.cart_url}?sections=cart-drawer,cart-icon-bubble`)
        .then((response) => response.json())
        .then((response) => {
            let responseFormated = {
                sections: response
            }
            let cart_drawer = document.querySelector('cart-drawer');
            cart_drawer.renderContents(responseFormated,"discount",discountCode)
            
        })
      })
    .catch(error => {
        console.error("Error applying discount:", error.message);
    });
  }
}

customElements.define('cart-coupon-form', CartCouponCodeButton);




